import { LogiImg, LogoWrapper, LogoLink } from "../Header.styled";
import chemistry from "../../../assets/svg/chemistry.svg";
import { HeaderBox } from "./HeaderAdm.Styled";

const HeaderAdm = () => {
  return (
    <HeaderBox>
      <LogoWrapper>
        <LogiImg to="/">
          <img src={chemistry} alt="main logo" width={40} height={40} />
        </LogiImg>
        <LogoLink>Chemistry tasks</LogoLink>
      </LogoWrapper>
    </HeaderBox>
  );
};

export default HeaderAdm;
